<div class="d-flex flex-column gap-3 cancel-dialog">
	<h3 class="p-0" mat-dialog-title>Data Anulacji {{ todayDate }}</h3>
	<div class="group d-flex flex-column gap-2">
		<p>
			Wartość rezerwacji przed anulacją:
			{{ +reservation?.totalPrice | price }}{{ reservation?.currency?.code }}
		</p>
		<p>
			Wartość składników objętych anulacją:
			{{ +reservation?.valueOfComponentsToCancel | price }}
			{{ reservation?.currency?.code }}
		</p>
	</div>

	<div class="group d-flex flex-column gap-2">
		<p *ngIf="dialogData.offerId">Ilość dni przed wyjazdem: {{ daysBeforeDeparture }}</p>
		<p *ngIf="dialogData.offerId">Procent anulacji: {{ cancellationPercentage }}%</p>
		<p>
			Koszty anulacji:
			<ng-container *ngIf="isReservation">
				{{ +reservation?.costToCancel | price }}
			</ng-container>
			<ng-container *ngIf="isOffer">
				{{ +offer?.costToCancel | price }}
			</ng-container>
			<ng-container *ngIf="isSlot">
				{{ +slot?.costToCancel | price }}
			</ng-container>
			{{ reservation?.currency?.code }}
		</p>
	</div>
	<mat-form-field
		appearance="outline"
		class="custom"
		*ngIf="authService.permissionsByCode()[Permissions.NEW_RESERVATION_SYSTEM]"
	>
		<mat-label>Ręczne koszty anulacji</mat-label>

		<input type="number" placeholder="Kwota" [(ngModel)]="frontendCancellationPrice" matInput />
		<mat-hint align="end"
			>Uwaga. Ręczne koszty anulacji mogą się zmienić w zależnosci od alertu lub ilości dni przed wyjazdem.
		</mat-hint>
	</mat-form-field>
	<mat-form-field appearance="outline" class="custom cancellationReasonFormField">
		<mat-label>Powód anulacji</mat-label>
		<mat-select [(ngModel)]="cancellationReasonId" required>
			<mat-option *ngFor="let reason of cancellationReasons | async" [value]="reason.id">{{
				reason.name
			}}</mat-option>
		</mat-select>
		<mat-error class="mt-3">Powód anulacji jest wymagany!</mat-error>
	</mat-form-field>
</div>
<mat-dialog-actions class="d-flex flex-row gap-2 mt-3">
	<button
		mat-raised-button
		color="warn"
		*ngIf="authService.permissionsByCode()[Permissions.NEW_RESERVATION_SYSTEM]"
		(click)="cancel(true)"
		[disabled]="!!frontendCancellationPrice || !cancellationReasonId"
	>
		Anuluj bezkosztowo
	</button>
	<button
		mat-raised-button
		class="cancelButton"
		color="accent"
		(click)="cancel()"
		[disabled]="!isCancelledByOskar && !cancellationReasonId"
	>
		{{ cancelButtonText }}
	</button>
	<button mat-raised-button color="primary" (click)="closeDialog()">Wróć</button>
</mat-dialog-actions>
